<template>
  <div class="contact-page" :class="{ 'is-en': isEn }">
    <site-header />
    <section class="page-banner" :style="{ backgroundImage: 'url(' + banner + ')' }"></section>
    <section class="title-block">
      <div class="stage">
        <span class="name">{{ copy.contact.name }}</span>
        <span class="name-blue">{{ copy.contact.nameBlue }}</span>
        <div class="en-line">CONTACT US</div>
      </div>
    </section>
    <section class="info">
      <div class="stage">
        <div class="icon icon-phone">
          <img :src="phoneIcon" :alt="copy.contact.phone">
        </div>
        <div class="icon icon-addr">
          <img :src="addrIcon" :alt="copy.contact.address">
        </div>
        <div class="icon icon-mail">
          <img :src="mailIcon" :alt="copy.contact.email">
        </div>
        <p class="line line-phone">{{ copy.contact.phone }}</p>
        <p class="line line-addr">{{ copy.contact.address }}</p>
        <p class="line line-mail">{{ copy.contact.email }}</p>
        <div ref="map" class="map-box tencent_map_style_03"></div>
      </div>
    </section>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { fileUrl } from '@/utils/fileUrl'
import { getCopy } from '@/locale'

/** 官网联系我们页正在使用的腾讯地图脚本 */
const MAP_SCRIPT = 'https://map.qq.com/api/gljs?v=1.exp&libraries=service&key=MRQBZ-IDACQ-VAK54-4KWQI-V5TWV-RIFQ6'

export default {
  name: 'ContactPage',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      banner: fileUrl('contactUs/contactUs_banner.jpg'),
      phoneIcon: fileUrl('contactUs/20170103104557344.png'),
      addrIcon: fileUrl('contactUs/201701031045578.png'),
      mailIcon: fileUrl('contactUs/20170103104557279.png'),
      map: null,
      infoWindow: null,
      markerLayer: null,
      infoOpen: true
    }
  },
  computed: {
    /** 是否英文站 */
    isEn() {
      return this.$route.meta && this.$route.meta.lang === 'en'
    },
    /** 按路由语言取联系文案 */
    copy() {
      return getCopy(this.isEn ? 'en' : 'zh')
    }
  },
  mounted() {
    this.loadMap()
  },
  beforeDestroy() {
    this.destroyMap()
  },
  methods: {
    /** 加载官网同一段腾讯地图脚本，已有则直接初始化 */
    loadMap() {
      if (window.TMap) {
        this.initMap()
        return
      }
      const existed = document.getElementById('tmap-gljs')
      if (existed) {
        existed.addEventListener('load', this.onMapScriptLoad)
        return
      }
      const script = document.createElement('script')
      script.id = 'tmap-gljs'
      script.src = MAP_SCRIPT
      script.onload = this.onMapScriptLoad
      document.body.appendChild(script)
    },
    /** 脚本加载完成后初始化地图 */
    onMapScriptLoad() {
      if (this._isDestroyed) {
        return
      }
      this.initMap()
    },
    /** 按官网坐标放针，并打开公司名和地址（中英随路由切换） */
    initMap() {
      const TMap = window.TMap
      const center = new TMap.LatLng(22.618359, 114.041197)
      const map = new TMap.Map(this.$refs.map, {
        center: center,
        zoom: 13
      })
      this.map = map
      this.markerLayer = new TMap.MultiMarker({
        map: map,
        styles: {
          myStyle: new TMap.MarkerStyle({
            width: 22,
            height: 30
          })
        },
        geometries: [{
          id: '1',
          styleId: 'myStyle',
          position: center
        }]
      })
      // 拼气泡 HTML：公司名与地址走 locale，与官网中英文一致
      const infoWindow = new TMap.InfoWindow({
        map: map,
        position: center,
        offset: { x: 0, y: -42 },
        enableCustom: true,
        content: this.buildMapInfoHtml()
      })
      this.infoWindow = infoWindow
      this.onCloseInfo = this.closeInfo.bind(this)
      this.onMarkerClick = this.toggleInfo.bind(this)
      const closeBtn = this.$refs.map.querySelector('.close_img')
      if (closeBtn) {
        closeBtn.addEventListener('click', this.onCloseInfo)
      }
      this.markerLayer.on('click', this.onMarkerClick)
    },
    /** 生成地图信息窗 HTML，英文站用官网英文公司名与地址 */
    buildMapInfoHtml() {
      const company = this.copy.contact.mapCompany
      const address = this.copy.contact.mapAddress
      return '<div class="card_view"><div class="info_card"><div class="title_view"><span class="title_name">' + company + '</span><img class="close_img" src="https://cdn.yun.sooce.cn/5/1598/webp/25a8d13f80e86e642aec29b3eae43380.webp" alt=""></div><div class="content_view">' + address + '</div></div><img class="triangle_img" src="https://cdn.yun.sooce.cn/5/1598/png/1722841344084e24e59f99bbb1ae236c1721833924b50.png" alt=""><span class="triangle_pot"></span></div>'
    },
    /** 点击标注开关信息窗 */
    toggleInfo() {
      if (!this.infoWindow) {
        return
      }
      if (this.infoOpen) {
        this.infoWindow.close()
        this.infoOpen = false
      } else {
        this.infoWindow.open()
        this.infoOpen = true
      }
    },
    /** 关闭公司信息窗 */
    closeInfo() {
      if (this.infoWindow) {
        this.infoWindow.close()
        this.infoOpen = false
      }
    },
    /** 离开页面时拆掉地图实例 */
    destroyMap() {
      if (this.markerLayer) {
        this.markerLayer.off('click', this.onMarkerClick)
        this.markerLayer.setMap(null)
        this.markerLayer = null
      }
      if (this.map) {
        this.map.destroy()
        this.map = null
      }
      this.infoWindow = null
    }
  }
}
</script>

<style scoped>
.contact-page {
  background: #fff;
  color: #333;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}
.page-banner {
  height: 500px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}
.stage {
  position: relative;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
}
.title-block { height: 174px; }
.name,
.name-blue {
  position: absolute;
  top: 55px;
  z-index: 2;
  font-size: 30px;
  line-height: 50px;
  letter-spacing: 2px;
  background: #fff;
  white-space: nowrap;
}
.name {
  left: 43.166667%;
  width: 6.666667%;
  text-align: right;
}
.name-blue {
  left: 49.916667%;
  width: 7.25%;
  color: #3db7ef;
  font-weight: bold;
  text-align: left;
}
.en-line {
  position: absolute;
  top: 83px;
  left: 35.708333%;
  width: 28.583333%;
  border-top: 1px dashed #3db7ef;
  line-height: 90px;
  font-size: 22px;
  font-weight: bold;
  font-family: Tahoma, sans-serif;
  color: #e5e5e5;
  text-align: center;
}
.info { height: 886px; }
.icon {
  position: absolute;
  top: 41px;
  height: 100px;
  border-radius: 50%;
  box-sizing: border-box;
  text-align: center;
}
.icon img {
  width: 52px;
  height: auto;
}
.icon-phone {
  left: 17.958333%;
  width: 8.333333%;
  background: #fca733;
  padding: 30px 24px 13px;
}
.icon-addr {
  left: calc(50% - 50px);
  width: 100px;
  background: #79bdfc;
  padding: 13px 24px;
}
.icon-mail {
  left: 73.8%;
  width: 8.333333%;
  background: #db6460;
  padding: 33px 24px 13px;
}
.line {
  position: absolute;
  top: 154px;
  margin: 0;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #333;
}
.line-phone { left: 13.875%; width: 16.5%; }
.line-addr { left: 36.833333%; width: 26.333333%; }
.line-mail { left: 65.341146%; width: 25.25%; }
/* 英文站定位对齐官网 contactUs_EN.html */
.contact-page.is-en .name {
  left: 40.583333%;
  width: 13.333333%;
}
.contact-page.is-en .name-blue {
  left: 54.5%;
  width: 4.416667%;
}
.contact-page.is-en .line-phone {
  left: 11.791667%;
  width: 18.583333%;
}
.map-box {
  position: absolute;
  top: 243px;
  left: 0;
  width: 100%;
  height: 554px;
}
@media (min-width: 641px) and (max-width: 1200px) {
  .page-banner { height: 350px; }
  .title-block { height: 223px; }
  .name,
  .name-blue { top: 31px; font-size: 28px; }
  .name { left: 43.123674%; width: 67px; }
  .name-blue { left: 50.102731%; width: 7.604167%; }
  .en-line { top: 55px; left: 35.708008%; }
  .info { height: 707px; }
  .icon { top: 39px; }
  .icon-phone { left: 10.041092%; width: 10.416667%; }
  .icon-mail { left: 79.6%; width: 10.416667%; }
  .line { top: 151px; }
  .line-phone { left: 4.261665%; width: 207px; }
  .line-addr { left: 33.138918%; width: 33.722163%; }
  .line-mail { left: 70.90403%; width: 27.783669%; }
}
@media (max-width: 640px) {
  .page-banner { height: 250px; }
  .title-block { height: 213px; }
  .name,
  .name-blue { top: 20px; font-size: 26px; }
  .name { left: 31.953125%; width: 18.125%; }
  .name-blue { left: 50.263158%; width: 19.0625%; }
  .en-line {
    top: 46px;
    left: 18.947368%;
    width: 62.105263%;
    height: 70px;
    line-height: 80px;
  }
  .info { height: 570px; }
  .icon { width: 50px; height: 50px; left: 4.536133%; }
  .icon img { width: 26px; }
  .icon-phone { top: 8px; padding: 12px 10px 10px; }
  .icon-addr { top: 69px; padding: 9px 13px 11px; }
  .icon-mail { top: 133px; padding: 14px 10px 10px; }
  .line { text-align: left; }
  .line-phone { top: 23px; left: 22.865014%; width: 54.269972%; }
  .line-addr { top: 84px; left: 22.988281%; width: 66.5625%; }
  .line-mail { top: 148px; left: 22.988281%; width: 73.75%; }
  .map-box {
    top: 0;
    left: 2.5%;
    width: 95%;
    height: 300px;
  }
}
</style>

<style>
.tencent_map_style_03 .card_view { position: relative; }
.tencent_map_style_03 .card_view .info_card {
  background: #fff;
  border: 1px solid #ABABAB;
  padding: 10px;
  min-width: 180px;
  max-width: 230px;
}
.tencent_map_style_03 .info_card .title_view { overflow: hidden; }
.tencent_map_style_03 .info_card .title_view .title_name {
  font-size: 14px;
  font-weight: bold;
  float: left;
  width: calc(100% - 26px);
}
.tencent_map_style_03 .info_card .title_view .close_img {
  width: 12px;
  margin-left: 14px;
  float: right;
  position: relative;
  top: 4px;
  cursor: pointer;
}
.tencent_map_style_03 .info_card .content_view {
  font-size: 14px;
  margin-top: 6px;
  color: #666;
}
.tencent_map_style_03 .card_view .triangle_img {
  position: absolute;
  top: calc(100% - 10px);
  left: 50%;
  z-index: -1;
}
.tencent_map_style_03 .card_view .triangle_pot {
  width: 20px;
  display: inline-block;
  position: absolute;
  background: #fff;
  height: 2px;
  top: calc(100% - 2px);
  left: calc(50% + 7px);
}
</style>
